var _path, _g, _path2, _path3, _g2, _path4, _path5, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgReportSinceInactive = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 508,
    height: 501,
    viewBox: "0 0 508 501",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M299.306 369.103C299.622 369.419 299.622 369.932 299.304 370.247C274.744 394.575 243.387 410.901 209.359 417.063C175.064 423.273 139.691 418.864 107.969 404.427C76.248 389.99 49.6906 366.212 31.8487 336.272C14.0068 306.333 5.73097 271.66 8.12786 236.891C10.5247 202.121 23.4801 168.912 45.2615 141.704C67.0429 114.496 96.6119 94.5872 130.014 84.6392C163.417 74.6912 199.06 75.1785 232.178 86.0358C265.039 96.809 293.86 117.283 314.849 144.751C315.121 145.106 315.05 145.615 314.694 145.885L179.605 248.099C179.213 248.396 179.174 248.97 179.521 249.318L299.306 369.103Z",
    fill: "#CDD2DC",
    stroke: "#ACB4C4",
    strokeWidth: 15.3889
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1434_2596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.484 28.2071C187.484 23.5357 191.271 19.7487 195.943 19.7487L399.712 19.7461C401.924 19.7461 404.047 20.6118 405.627 22.1579L483.756 98.5806C485.383 100.172 486.3 102.352 486.3 104.627V472.834C486.3 477.506 482.513 481.293 477.842 481.293H195.943C191.271 481.293 187.484 477.506 187.484 472.834V28.2071Z",
    fill: "#CDD2DC"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M399.712 11.2418L195.943 11.2443C186.574 11.2444 178.98 18.8389 178.98 28.2071V472.834C178.98 482.203 186.575 489.797 195.943 489.797H477.842C487.21 489.797 494.805 482.203 494.805 472.834V104.627C494.805 100.064 492.966 95.6924 489.703 92.5011L411.574 16.0784C408.404 12.9778 404.146 11.2417 399.712 11.2418Z",
    stroke: "#ACB4C4",
    strokeWidth: 17.0087,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M403.449 100.618V12.2767C403.449 11.5501 404.332 11.191 404.839 11.7114L490.934 100.052C491.434 100.566 491.07 101.428 490.354 101.428H404.259C403.812 101.428 403.449 101.065 403.449 100.618Z",
    fill: "#CDD2DC",
    stroke: "#ACB4C4",
    strokeWidth: 15.7938
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1434_2596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.699 216.122V51.4623C216.699 51.015 217.066 50.6521 217.513 50.6544C305.851 51.0925 378.594 122.691 379.015 216.117C379.017 216.564 378.654 216.932 378.207 216.932H217.509C217.062 216.932 216.699 216.569 216.699 216.122Z",
    fill: "#CDD2DC"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M216.699 216.122V51.4623C216.699 51.015 217.066 50.6521 217.513 50.6544C305.851 51.0925 378.594 122.691 379.015 216.117C379.017 216.564 378.654 216.932 378.207 216.932H217.509C217.062 216.932 216.699 216.569 216.699 216.122Z",
    stroke: "#ACB4C4",
    strokeWidth: 15.3889
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M349.195 248.66C349.642 248.66 350.005 249.024 350.003 249.471C349.844 283.037 339.817 315.822 321.162 343.741C302.357 371.885 275.628 393.821 244.356 406.774C213.085 419.727 178.674 423.116 145.476 416.513C112.543 409.962 82.2702 393.869 58.4231 370.247C58.1053 369.932 58.1051 369.419 58.4214 369.103L178.626 248.898C178.778 248.746 178.984 248.66 179.199 248.66H349.195Z",
    fill: "#CDD2DC",
    stroke: "#ACB4C4",
    strokeWidth: 15.3889
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 371.799,
    y: 19.7461,
    width: 23.6241,
    height: 21.3085,
    fill: "#CDD2DC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1434_2596",
    x: 170.477,
    y: 2.73828,
    width: 332.832,
    height: 495.562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -43.3318,
    dy: 2.02485
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.67451 0 0 0 0 0.705882 0 0 0 0 0.768627 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1434_2596"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1434_2596",
    x: 209.004,
    y: 42.9609,
    width: 177.705,
    height: 181.664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -31.1827,
    dy: 10.5292
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1434_2596"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportSinceInactive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reportSinceInactive.7c17042afc3aa00132b502e5fe0fc1ac.svg";